export default "__VITE_ASSET__CFs2YkOa__"